export default __webpack_public_path__ + "static/media/logo.33dc28ab.svg";